import { useSelector } from 'react-redux'
import { selectChartPanes } from '../../../selectors/chart'
import React, { memo } from 'react'
import ChartPane from '../chartPane/chartPane'
import { TradeOptions } from '../../../reducer/scalper.reducer'

/** Stable id per pane DOM node so ChartPane remounts when lightweight-charts replaces pane elements (avoids portal/commit on detached nodes). */
const chartPaneHostKeys = new WeakMap<HTMLDivElement, number>()
let nextChartPaneHostKey = 1
function chartPaneHostKey(el: HTMLDivElement) {
    let k = chartPaneHostKeys.get(el)
    if (k === undefined) {
        k = nextChartPaneHostKey++
        chartPaneHostKeys.set(el, k)
    }
    return k
}

export type ChartMetadataProps = {
    viewKey: string
    paneElements: HTMLDivElement[]
    showLogo: boolean
    primary: boolean
    screenerChart: boolean,
    tradeOptions?: TradeOptions,
    onSecuritySelected?: (key: string, expressionMode: boolean, securities: string[]) => void
}

const ChartMetadata: React.FC<ChartMetadataProps> = memo(({
                                                              viewKey,
                                                              paneElements,
                                                              showLogo,
                                                              primary,
                                                              screenerChart,
                                                              tradeOptions,
                                                              onSecuritySelected
                                                          }) => {
    const chartPanes = useSelector(selectChartPanes(viewKey))
    if (!paneElements.length || !chartPanes.length) return null

    return <>
        {paneElements.map((ele, i) => (
            <ChartPane
                id={chartPanes[i]}
                viewKey={viewKey}
                container={ele}
                index={i}
                key={`${viewKey}-${chartPanes[i] ?? i}-${i}-h${chartPaneHostKey(ele)}`}
                showLogo={showLogo}
                screenerChart={screenerChart}
                primaryChart={primary}
                onSecuritySelected={onSecuritySelected}
                tradeOptions={tradeOptions}
            />
        ))}
    </>
})

ChartMetadata.displayName = 'ChartMetadata'

export { ChartMetadata }
